export const getDefaultAdminFormModel = () => ({
    email: '',
    firstName: '',
    lastName: ''
});
export const getDefaultAdminsFilterFormModelState = () => ({
    status: []
});
